module.exports = __webpack_public_path__ + "static/media/Liikuntaohjeet_DM1.b85541bf.jpg";